import { sortOptions } from "../mocks/sort.mocks"

export const get = (obj, path, def) => {
  const fullPath = path
    .replace(/\[/g, ".")
    .replace(/]/g, "")
    .split(".")
    .filter(Boolean)
  return fullPath.every(everyFunc) ? obj : def
  function everyFunc(step) {
    return !(step && obj && (obj = obj[step]) === undefined)
  }
}

// deep cloning object to avoid object reference
export const deepCloneSimpleObject = obj => {
  if (obj) return JSON.parse(JSON.stringify(obj))
}

export const deslashify = origUrl => {
  const url = origUrl?.trim().endsWith("/") ? origUrl.slice(0, -1) : origUrl
  return url
}
// adding this function to remove expressions from slug
export const replaceAll = (str, find, replace) => {
  const expression = find.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  return str?.replace(new RegExp(expression, "g"), replace)
}

const getLoc = (data, countryListData) => {
  let result = []
  let locName
  let countryName
  let locId
  data?.map(itm => {
    locId = itm
    countryListData?.map(country => {
      country?.locations?.length > 0 &&
        country?.locations?.map(location => {
          if (location?.value == itm) {
            locName = location?.label
            countryName = country?.countryName
          }
        })
    })
    result.push({
      locName: locName,
      countryName: countryName,
      locId: itm,
    })
  })
  return result
}

export const getLocDets = (data, countryListData = []) => {
  const primLoc =
    data?.Primary_Location_Reference.length > 0 &&
    getLoc(data?.Primary_Location_Reference, countryListData)
  return primLoc
}

export const getFuncName = (lab, filterListData = []) => {
  let currentFunc = ""
  const functions = filterListData?.selectFields?.jobFamily?.options
  functions?.map(itm => {
    if (itm?.value?.split("|")?.includes(lab)) {
      currentFunc = itm?.label
    }
  })
  return currentFunc
}

export const isBrowser = () => typeof window !== "undefined"

export const isElement = (elem) => {
  return elem instanceof Element;
}

export const scrollIntoViewIfNeeded = (elem) => {
  if (isElement(elem)) {
    const rectElem = elem.getBoundingClientRect()
    if (rectElem.bottom > window.innerHeight) elem.scrollIntoView(false);
    else if (rectElem.top < 0) elem.scrollIntoView();
  }
}

export const getSourceDomain = (sourceSiteURL, utmParams) => {
  const utm = utmParams?.toLowerCase() || ""
  const url = sourceSiteURL?.toLowerCase() || ""

  if (utm.includes("utm_medium=phenom_newsletter")) return "source=Phenom_Newsletter"
  if (utm.includes("utm_medium=recruiter_social_post")) return "source=Recruiter_Social_post"
  if (utm.includes("utm_source=email")) return "source=CRM_Candidate"

  if (utm.includes("utm_medium=paid")) {
    const paidSources = {
      google: "APPLICANT_SOURCE-6-115",
      linkedin: "APPLICANT_SOURCE-6-112",
      facebook: "APPLICANT_SOURCE-6-113",
      tiktok: "APPLICANT_SOURCE-6-114",
      instagram: "APPLICANT_SOURCE-6-116",
    }
    for (const [key, value] of Object.entries(paidSources)) {
      if (utm.includes(`utm_source=${key}`)) return `source=${value}`
    }
    return "source=APPLICANT_SOURCE-6-117"
  }

  const sourceMap = [
    ["mondelezinternational", "Company_Website"],
    ["google", "Google"],
    ["naukri", "APPLICANT_SOURCE-3-59"],
    ["monster", "APPLICANT_SOURCE-3-53"],
    ["indeed", "APPLICANT_SOURCE-3-71"],
    ["linkedin", "APPLICANT_SOURCE-3-39"],
    ["bumeran", "APPLICANT_SOURCE-3-43"],
    ["zonajobs", "APPLICANT_SOURCE-3-46"],
    ["vegas", "APPLICANT_SOURCE-3-47"],
    ["pcdonline", "APPLICANT_SOURCE-3-48"],
    ["equitek", "APPLICANT_SOURCE-3-49"],
    ["nbmbaa", "APPLICANT_SOURCE-3-50"],
    ["prospanica", "APPLICANT_SOURCE-3-51"],
    ["drive my way", "APPLICANT_SOURCE-3-52"],
    ["careerbuilder", "APPLICANT_SOURCE-3-54"],
    ["craigslist", "APPLICANT_SOURCE-3-55"],
    ["seek", "APPLICANT_SOURCE-3-56"],
    ["gradconnection", "APPLICANT_SOURCE-3-57"],
    ["student job board", "APPLICANT_SOURCE-3-58"],
    ["iimjobs", "APPLICANT_SOURCE-3-60"],
    ["totaljobs", "APPLICANT_SOURCE-3-61"],
    ["cadremploi", "APPLICANT_SOURCE-3-62"],
    ["infojobs", "APPLICANT_SOURCE-3-63"],
    ["praca", "APPLICANT_SOURCE-3-64"],
    ["profesia.sk", "APPLICANT_SOURCE-3-66"],
    ["stepstone", "APPLICANT_SOURCE-3-67"],
    ["finn", "APPLICANT_SOURCE-3-68"],
    ["irishjobs", "APPLICANT_SOURCE-3-69"],
    ["facebook", "Facebook"],
    ["tiktok", "APPLICANT_SOURCE-3-41"],
    ["instagram", "Instagram"],
    ["ziprecruiter", "ziprecruiter.com"],
    ["adzuna", "Adzuna"],
    ["neuvoo", "Talent"],
    ["talent", "Talent"],
    ["chatgpt", "ChatGPT"],
    ["bing", "Bing"],
    ["yahoo", "Yahoo"],
    ["jobs", "APPLICANT_SOURCE-3-65"],
  ]

  for (const [key, value] of sourceMap) {
    if (utm.includes(`utm_source=${key}`)) return `source=${value}`
  }

  for (const [key, value] of sourceMap) {
    if (url.includes(key)) return `source=${value}`
  }

  return "source=Company_Website"
}

export const getUTMParams = searchParams => {
  const urlParams = new URLSearchParams(searchParams)
  const utmSource = urlParams.get("utm_source")
  const utmMedium = urlParams.get("utm_medium")
  const utmCampaign = urlParams.get("utm_campaign")
  const utmTerm = urlParams.get("utm_term")
  const utmContent = urlParams.get("utm_content")
  let utmParams = ""
  if (utmSource) utmParams += `&utm_source=${utmSource}`
  if (utmMedium) utmParams += `&utm_medium=${utmMedium}`
  if (utmCampaign) utmParams += `&utm_campaign=${utmCampaign}`
  if (utmTerm) utmParams += `&utm_term=${utmTerm}`
  if (utmContent) utmParams += `&utm_content=${utmContent}`
  if (utmParams.startsWith("&")) {
    utmParams = utmParams.slice(1)
  }
  return utmParams
}